import { Button } from '@design/components/button/Button';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './NoDataFound.module.scss';

export interface NoDataFoundProps {
  bannerPath: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
  buttonTestId?: string;
  children?: ReactNode;
  className?: string;
  size?: 'default' | 'small';
}

export const NoDataFound = ({
  bannerPath,
  title,
  description,
  buttonLabel,
  buttonAction,
  buttonTestId,
  children,
  className,
  size = 'default',
  ...rest
}: NoDataFoundProps) => {
  return (
    <div
      className={clsx(
        styles.emptyPortfolioWrapper,
        {
          [styles.small]: size === 'small',
        },
        className
      )}
      {...rest}
    >
      <img className={styles.styledImg} src={bannerPath} />
      <span data-title className={styles.title}>
        {title}
      </span>
      <span className={styles.description}>{description}</span>
      {buttonAction && (
        <Button
          className={styles.addAssetsButton}
          {...(buttonTestId ? { 'data-testid': buttonTestId } : {})}
          onClick={buttonAction}
          label={buttonLabel}
        />
      )}
      {children}
    </div>
  );
};
